import { NgModule } from '@angular/core';

import { SharedModule } from '../../../../shared';

import { IntegrationCarteiraPedidoModalComponent } from './integration-carteira-pedido-modal.component';

@NgModule({
    imports: [
        SharedModule,
    ],
    declarations: [
        IntegrationCarteiraPedidoModalComponent
    ],
    exports: [
        IntegrationCarteiraPedidoModalComponent
    ]
})
export class IntegrationCarteiraPedidoSharedModule { }
